import { Button, Stack } from "@mui/material";
import PdfFieldCanvas from "components/DocumentMapping/PdfFieldCanvas";

/** Page-switcher row plus the drawing surface for the active page. */
const MappingPageCanvasPanel = ({
  previews,
  activePage,
  onActivePageChange,
  fields,
  selectedIndex,
  onSelectField,
  canEdit,
  onRectangleDrawn,
}) => (
  <>
    <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: "wrap" }}>
      {previews.map((_, index) => {
        const pageNumber = index + 1;
        return (
          <Button
            key={pageNumber}
            size="small"
            variant={activePage === pageNumber ? "contained" : "outlined"}
            onClick={() => onActivePageChange(pageNumber)}
          >
            Page {pageNumber}
          </Button>
        );
      })}
    </Stack>
    <PdfFieldCanvas
      pageImageUrl={previews[activePage - 1]}
      fields={fields}
      activePageNumber={activePage}
      selectedFieldIndex={selectedIndex}
      onSelectField={onSelectField}
      readOnly={!canEdit}
      onRectangleDrawn={onRectangleDrawn}
    />
  </>
);

export default MappingPageCanvasPanel;
